import { ApiClient, PublicApiClient } from "./RestApi";

export class BaseService {
  static getApiClient(): ApiClient {
    // const locale = getPersistedLanguage();
    const token = JSON.parse(localStorage.getItem("access_token"));

    return new ApiClient({
      Authorization: "Bearer " + token,
    });
  }

  static getPublicApiClient(): PublicApiClient {
    return new PublicApiClient({});
  }
}

export default BaseService;
